import { lazy } from 'react';

import RoutePaths from 'deposit/config/routes/route-paths';
import { createBrowserHistory, History } from 'history';

import { CommonRoutes } from 'common/config/routes/routes';
import { RouteType } from 'common/config/routes/routes.type';

export const history: History = createBrowserHistory();

const Routes: RouteType[] = [
  {
    path: RoutePaths.preload,
    component: lazy(() => import('deposit/pages/preload-page')),
  },
  {
    path: RoutePaths.authentication,
    component: lazy(() => import('deposit/pages/authentication-page')),
  },
  {
    path: RoutePaths.gateway,
    component: lazy(() => import('deposit/pages/public/gateway')),
  },
  {
    path: RoutePaths.manual,
    component: lazy(() => import('deposit/pages/voucher-summary-page/voucher-deposit-page')),
  },
  {
    path: RoutePaths.selectMethod,
    component: lazy(() => import('deposit/pages/select-method-page/index')),
  },
  {
    path: RoutePaths.reverseSelectMethod,
    component: lazy(() => import('deposit/pages/public/reverse-select-method/index')),
  },
  {
    path: RoutePaths.paymentSummary,
    component: lazy(() => import('deposit/pages/pm-summary-page')),
  },
  {
    path: RoutePaths.walletSummary,
    component: lazy(() => import('deposit/pages/wallet-summary-page')),
  },
  {
    path: RoutePaths.walletAddFunds,
    component: lazy(() => import('deposit/pages/wallet-add-funds')),
  },

  {
    path: RoutePaths.identityValidation,
    component: lazy(() => import('deposit/pages/identity-validation-page')),
  },
  {
    path: RoutePaths.profile,
    component: lazy(() => import('deposit/pages/profile-page')),
  },
  {
    path: RoutePaths.waiting,
    component: lazy(() => import('deposit/pages/wait-payment-page')),
  },
  {
    path: RoutePaths.pay,
    component: lazy(() => import('deposit/pages/pay-page/pay.page')),
  },
  {
    path: RoutePaths.completed,
    component: lazy(() => import('deposit/pages/completed-page')),
  },
  {
    path: RoutePaths.error,
    component: lazy(() => import('deposit/pages/error-page')),
  },
  {
    path: RoutePaths.merchantRedirect,
    component: lazy(() => import('deposit/pages/merchant-init-page')),
  },
  {
    path: RoutePaths.addCard,
    component: lazy(() => import('deposit/pages/add-card-page')),
  },
  {
    path: RoutePaths.selectCard,
    component: lazy(() => import('deposit/pages/select-card-page')),
  },
  {
    path: RoutePaths.cardSummary,
    component: lazy(() => import('deposit/pages/card-deposit-summary-page')),
  },
  {
    path: RoutePaths.subscriptionSummary,
    component: lazy(() => import('deposit/pages/subscriptions/subscription-summary-page')),
  },
  {
    path: RoutePaths.subscriptionSelectMethodPage,
    component: lazy(() => import('deposit/pages/subscriptions/subscription-select-method-page')),
  },
  {
    path: RoutePaths.subscriptionCompletedPage,
    component: lazy(() => import('deposit/pages/subscriptions/subscription-completed-page')),
  },
  {
    path: RoutePaths.checkoutPage,
    component: lazy(() => import('deposit/pages/public/public-checkout-page')),
  },
  ...CommonRoutes,
];

export default Routes;
